import type { Dispatch, SetStateAction } from 'react'

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'

import type { WorkflowRequestForm } from '../types/admin.types'

type RequestChangesDialogProps = {
  open: boolean
  requestForm: WorkflowRequestForm
  onClose: () => void
  onSubmit: () => void
  setRequestForm: Dispatch<SetStateAction<WorkflowRequestForm>>
}

const REQUEST_TYPES = [
  'Technical correction required',
  'Formatting / template correction',
  'Missing attachment or image',
  'Broken link or reference',
  'Classification / metadata correction',
]

export function RequestChangesDialog({
  open,
  requestForm,
  onClose,
  onSubmit,
  setRequestForm,
}: RequestChangesDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Request Changes</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2} mt={1}>
          <FormControl fullWidth>
            <InputLabel>Request Type</InputLabel>
            <Select
              value={requestForm.request_type}
              label="Request Type"
              onChange={event => setRequestForm(form => ({ ...form, request_type: event.target.value }))}
            >
              {REQUEST_TYPES.map(requestType => (
                <MenuItem key={requestType} value={requestType}>
                  {requestType}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Comments to Author"
            multiline
            rows={4}
            fullWidth
            required
            value={requestForm.comment}
            onChange={event => setRequestForm(form => ({ ...form, comment: event.target.value }))}
            placeholder="Describe what changes are needed..."
          />
          <TextField
            label="Deadline for Resubmission"
            fullWidth
            value={requestForm.deadline}
            onChange={event => setRequestForm(form => ({ ...form, deadline: event.target.value }))}
            placeholder="Example: 2026-04-15"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" color="warning" onClick={onSubmit} disabled={!requestForm.comment}>
          Send Request
        </Button>
      </DialogActions>
    </Dialog>
  )
}
